import { CubicBezier, } from "./bezier.js";
export const splitBezier = (curve, threshold, tag = undefined, //tag all curves that lie above/after the threshold
dimension = "y", inverse = false) => {
    let dissectLine;
    let toThreshold;
    let getTag;
    if (dimension === "y") {
        dissectLine = (cp) => ({
            p1: { x: curve.cp[0].x, y: threshold },
            p2: { x: curve.cp[3].x, y: threshold },
        });
        toThreshold = (p) => (p.y = threshold);
        getTag = inverse
            ? (p) => (p.y < threshold ? tag : undefined)
            : (p) => (p.y > threshold ? tag : undefined);
    }
    else {
        dissectLine = (cp) => ({
            p1: { x: threshold, y: curve.cp[0].y },
            p2: { x: threshold, y: curve.cp[3].y },
        });
        toThreshold = (p) => (p.x = threshold);
        getTag = inverse
            ? (p) => (p.x < threshold ? tag : undefined)
            : (p) => (p.x > threshold ? tag : undefined);
    }
    const line = dissectLine(curve.cp);
    const t = CubicBezier.t(curve, line);
    if (t.length == 0) {
        //no intersections
        //use the first control point to see whether we are under or above
        curve.tag = getTag(curve.cp[0]);
        return [curve];
    }
    else if (t.length == 4) {
        //curve is colinear with the threshold line
        //the inverse parameter determines whether we are under or above
        curve.tag = inverse ? undefined : tag;
        //make sure that the coordinates are on the threshold
        curve.cp.forEach((p) => toThreshold(p));
        return [curve];
    }
    else {
        const curveStartsFromThreshold = t.at(0) == 0.0;
        const curveEndsOnThreshold = t.at(-1) == 1.0;
        if (curveStartsFromThreshold) {
            //make sure that cp0 is on the threshold
            toThreshold(curve.cp[0]);
        }
        if (curveEndsOnThreshold) {
            //curve ends on the threshold
            //make sure that cp3 is on the threshold
            toThreshold(curve.cp[3]);
        }
        if (t.length == 1 && (curveStartsFromThreshold || curveEndsOnThreshold)) {
            //depending on which end of the curve hits the threshold, the other end determines whether we are under or above
            curve.tag = getTag(curve.cp[curveStartsFromThreshold ? 3 : 0]);
            return [curve];
        }
        else {
            //splits can only be made for 0 < t < 1
            const tSplits = t.filter((_t) => _t > 0.0 && _t < 1.0);
            const postSplitProcessor = (curves) => {
                if (curves.length >= 2) {
                    const curve0 = curves.at(-2);
                    const curve1 = curves.at(-1);
                    toThreshold(curve0.cp[3]);
                    toThreshold(curve1.cp[0]);
                    curve1.tag = curve0.tag ? undefined : tag;
                }
            };
            //make the splits
            curve.tag = getTag(curve.cp[0]);
            const splittedCurve = CubicBezier.splitAtT(curve, t, postSplitProcessor);
            if (t.length == 1 && getTag(curve.cp[0]) === getTag(curve.cp[3])) {
                //special case, the curve touches the threshold but does not make an incursion -> no need for a split
                curve.tag = getTag(curve.cp[0]);
                return [curve];
            }
            return splittedCurve;
        }
    }
};
